"use strict";exports.__esModule = true;exports.shift = void 0;var EPS = 0.00001;
var shift = exports.shift = function shift(value, _shift) {
  if (!value || !_shift) {
    return value;
  }
  var unitSymbolsArray = value.match(/[a-z]|%/g) || [];
  var unit = unitSymbolsArray.join('');
  var floatNumber = parseFloat(value) + parseFloat(_shift);
  var intNumber = parseInt("" + floatNumber, 10);
  var result = floatNumber % intNumber < EPS ? intNumber : Math.round(floatNumber * 10000) / 10000;
  return "" + result + (unit || 'px');
};